import { render, staticRenderFns } from "./DialogAddLaw.vue?vue&type=template&id=b022674e"
import script from "./DialogAddLaw.vue?vue&type=script&lang=js"
export * from "./DialogAddLaw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b022674e')) {
      api.createRecord('b022674e', component.options)
    } else {
      api.reload('b022674e', component.options)
    }
    module.hot.accept("./DialogAddLaw.vue?vue&type=template&id=b022674e", function () {
      api.rerender('b022674e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogAddLaw.vue"
export default component.exports